export default "__VITE_ASSET__NRIPmyNE__"